// extracted by mini-css-extract-plugin
export default {"draggingOkay":"FilePicker_draggingOkay__GGKSq","draggingNotOkay":"FilePicker_draggingNotOkay__iCecu"};